import SystemApi from './_systemApi';
import httpClient from '@/apis/base/httpclient';

class TaskManagerAPI extends SystemApi {
  constructor() {
    super();
  }
  controllerName = 'Systems';

  /**
   * Lấy task mới nhất của dữ liệu theo task_type, task_status
   * NVTUAN1 15.12.2023
   */
  async getTaskManagerLastest(param) {
    let request = {
      url: this.getAPIUrl() + '/task-manager-lastest',
      data: param
    };
    return await httpClient.getAsync(request);
  }
}

export default new TaskManagerAPI();